import cn from "classnames";

//components
import DisplayValue from "../DisplayValue";

// store
import { useSearchStore } from "store/searchStore";

import styles from "./SizeOverviewSection.module.scss";

export default function SizeOverviewSection() {
  const { business_profile } = useSearchStore();

  return (
    <div className={styles["size-overview-root"]}>
      <h2 className={styles["heading"]} id="size" tabIndex={-1}>
        Size
      </h2>

      <div className={styles["content"]}>
        <div className={styles["data-field"]}>
          <p className={styles["label"]}>Number of employees</p>
          <DisplayValue
            value={business_profile?.business_size}
          />
        </div>

        <div className={styles["data-field"]}>
          <p className={styles["label"]}>Annual gross revenue</p>
          <DisplayValue
            value={business_profile?.annual_revenue ? "$" + (business_profile?.annual_revenue || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "Not Provided"}
          />
        </div>
      </div>
    </div>
  );
}
